import React, {createRef} from 'react'
import { Form, Label, Input, Segment, Button , Ref} from 'semantic-ui-react'
import Timer from './Timer'
import Range from './Range'
import './FormBet.css'

const FixedBetButton = ({ factor, onClick, children }) => (
    <Button primary className='fixed-bet-btn' onClick={(e) => onClick(e, factor)}>
        {children}
    </Button>
)

export default class FormBet extends React.Component {

    minBet = 1
    
    constructor(props) {
        super(props)
        this.state = {
            currentBet: 20,
            startTime: 0,
            remainingTime: 0,
            timerId: 0
        }
        this.textInput = null;

        this.setTextInputRef = element => {
          this.textInput = element;
        };
    
        this.focusTextInput = () => {
          // Focus the text input using the raw DOM API
          if (this.textInput) this.textInput.focus();
          if (this.textInput) this.textInput.select();
        };
    }

    componentDidMount() {
        if (this.state.currentBet > this.props.balance)
            this.setState({ currentBet: this.props.balance });
        this.focusTextInput();
        const answer = document.querySelector( "[name=betinput]" );
        answer.addEventListener( "input", ( event ) => {
          if ( answer.validity.patternMismatch ) {
            answer.setCustomValidity("Inserisci un numero maggiore di 0");
          } else {
            answer.setCustomValidity( "" );
          }
        });
    }

    onBetChange = (e,{balance}) => {
        const val = e.target.value
        const onlyNumbersVal = val.replace(/\D/g, '')
        if (+onlyNumbersVal> balance){
            this.setState({ currentBet: balance })
        }  
        else {
            this.setState({ currentBet: +onlyNumbersVal })
        }
    }
    onRangeChange = (value) => this.setState({ currentBet: this.adjustBet(Math.round(value)) })

    onFixedBetClick = (e, factor) => {
        e.preventDefault();
        const wantedBet = Math.ceil(this.props.balance * factor)
        const bet = this.adjustBet(wantedBet)
        this.setState({ currentBet: bet })
    }
    
    adjustBet = (value) => {
        return Math.max(this.minBet, Math.min(value, this.props.balance));
    }

    placeBet = () => {
        const bet = this.adjustBet(this.state.currentBet)
        this.setState({ currentBet: bet })
        this.props.onBetClick(bet)
    }

    onSubmit = (e) => {
        e.preventDefault()
        this.placeBet()
        return false
    }

    onTimerFinished = () => {
        this.placeBet()
    }

    onFieldFocus = (e) => e.target.select()
    
    render() {
        const { question, balance } = this.props
        const { currentBet } = this.state
        

        return (
            <Form onSubmit={this.onSubmit}  style={{ textAlign: 'left' }}>
                <Segment style={{ maxWidth: '800px', margin: 'auto' }}>
                    <Label color='purple' ribbon>{question.topic}</Label>
                    <div style={{ textAlign: 'center' }}>
                        <Form.Field>
                            <label>Quanto scommetti?</label>
                            <Input  onMouseUp={this.onFieldFocus} balance={balance} onTouchEnd={this.onFieldFocus} onChange={this.onBetChange} fluid={false}>
                                <input ref={this.setTextInputRef}  
                                      id = "betinput"
                                      name = "betinput"
                                      type='text' pattern="[1-9][0-9]*" 
                                      balance = {balance}
                                      style={{ textAlign: 'center' }} value={currentBet} 
                                      />
                            </Input>
                        </Form.Field>
                        <div className='fixed-bet-btns'>
                            <FixedBetButton factor={1/3} onClick={this.onFixedBetClick}>33%</FixedBetButton>
                            <FixedBetButton factor={1/2} onClick={this.onFixedBetClick}>50%</FixedBetButton>
                            <FixedBetButton factor={1} onClick={this.onFixedBetClick}>100%</FixedBetButton>
                        </div>
                        <Range maxValue={balance} value={currentBet} onChange={this.onRangeChange} />
                        <Form.Button primary type="submit">Scommetti</Form.Button>
                        <Timer ms={this.props.betMs} />
                    </div>
                    <Timer ms={this.props.betMs} isProgress={true} onFinish={this.onTimerFinished} />
                </Segment>
            </Form>
        )
    }

}


// WEBPACK FOOTER //
// ./src/components/FormBet.js